import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-professional-tax-grid',
  templateUrl: './professional-tax-grid.component.html',
  styleUrls: ['./professional-tax-grid.component.css']
})
export class ProfessionalTaxGridComponent implements OnInit {

  public show1:boolean = false; 

  constructor() { }
 
  ngOnInit() {   }
 
  toggle1() {
    this.show1 = !this.show1;     
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/professional-tax/professional-tax-grid/professional-tax-grid.component.ts